import { render, staticRenderFns } from "./GridDocumentoDiarioProgreso.vue?vue&type=template&id=2d2a0742&"
import script from "./GridDocumentoDiarioProgreso.vue?vue&type=script&lang=js&"
export * from "./GridDocumentoDiarioProgreso.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports